module.exports = __webpack_public_path__ + "static/media/linkedin.30b3b81b.svg";